// extracted by mini-css-extract-plugin
export var author = "author-module--author--47d35";
export var category = "author-module--category--f0b6f";
export var headline = "author-module--headline--944a0";
export var headlinePost = "author-module--headline-post--96196";
export var paragraph = "author-module--paragraph--fb006";
export var post = "author-module--post--a045a";